import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(private http: HttpClient) { }


  downloadFile(url: string): Observable<any> {		
		return this.http.get(url, { responseType: 'blob' });
   }

}
